<div class="wrapper text-wrapper-carousel" (mouseenter)="pause()" (mouseleave)="unpause()">
  <p class="question">{{ 'didUKnow' | translate }}</p>
  <div class="text">
    @for (text of tipsTexts(); track text; let i = $index) {
      <p class="mb-0">
        @if (currentIndex() === i) {
          <span animate.enter="carousel-enter" animate.leave="carousel-leave">{{ text | translate }}</span>
        }
      </p>
    }
  </div>

  <div class="action-row ml-0">
    <div class="buttons ml-0">
      <button type="button" class="left ml-0" aria-label="Previous" (click)="previous()">
        <i class="fal fa-angle-left"></i>
      </button>
      <button type="button" class="right" aria-label="Next" (click)="next()"><i class="fal fa-angle-right"></i></button>
    </div>
    <div class="progressBar">
      <div class="progressBar2" [style.width]="progressBarLength()"></div>
    </div>
    <div class="progress-text">
      <span class="current-index">{{ currentIndex() + 1 }}</span>
      <span>/</span>
      <span class="total">{{ total() }}</span>
    </div>
  </div>
</div>
